import { render, staticRenderFns } from "./CareerAiConsentDialog.vue?vue&type=template&id=1fe97ed7&scoped=true"
import script from "./CareerAiConsentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerAiConsentDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CareerAiConsentDialog.vue?vue&type=style&index=0&id=1fe97ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe97ed7",
  null
  
)

export default component.exports